import { makeStyles } from '@material-ui/core/styles';

const useEnterAnimation = makeStyles(theme => ({
  enter: {
    animation: `$enter ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeOut}`,
    '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
  },
  '@keyframes enter': {
    '0%': { opacity: 0, transform: 'translateY(-8px)' },
    '100%': { opacity: 1, transform: 'translateY(0)' },
  },
}));

export default useEnterAnimation;
